import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';
import { IItem } from '@coreui/angular-pro'
import { RestService } from 'src/app/services/rest/rest.service';
import { GenericResponse, ServiceTypes, ServiceRequests } from 'src/app/interfaces/apiresponses';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';

interface GetDocumentData {
  id: number;
  documentTypeId?: number;
  documentName: string;
  base64Data: string;
}

@Component({
  selector: 'app-support-complaints',
  templateUrl: './support-complaints.component.html',
  styleUrls: ['./support-complaints.component.scss'],
  providers: [DatePipe]
})



export class SupportComplaintsComponent implements OnInit {
  bUndefined!: boolean
  selectedItem: any
  showUserForm = false;
  selectedUser: any;
  documents: GetDocumentData[] = [];
  documentGroups: any[] = [];
  currentComplaintIsOpen: boolean = true;

  // Alert buttons
  bAlert = false
  alertHeaderText = ""
  alertBodyText = ""
  bShowSecondAlertButton = false
  alertSecondButtonText = ""
  alertCloseButtonText = "Close"
  alertBoxData: any

  serviceTypes: any
  date = new Date();
  startDate = new Date(this.date.getFullYear(), this.date.getMonth(), 1);
  endDate = new Date(this.date.getFullYear(), this.date.getMonth() + 1, 0);

  columns = [
    {
      key: 'requestId',
      label: 'Request ID',
      _cellProps: { align: 'middle' },
      filter: true
    },
    {
      key: 'cif',
      label: 'CIF',
      _cellProps: { align: 'middle' },
      filter: true
    },
    {
      key: 'dateCreated',
      label: 'Created Date',
      _cellProps: { align: 'middle' },
      filter: true
    },
    {
      key: 'requestId',
      label: 'Complaint Number',
      _cellProps: { align: 'middle' },
      filter: true
    },
    {
      key: 'customerName',
      label: 'Customer Name',
      _cellProps: { align: 'middle' },
      filter: true
    },
    {
      key: 'requestType',
      label: 'Category',
      _cellProps: { align: 'middle' },
      filter: true
    },
    {
      key: 'response',
      label: 'Resolution Given',
      _cellProps: { align: 'middle' },
      filter: false
    },
    {
      key: 'isOpen',
      label: 'Status',
      filter: false
    },
    // {
    //   key: 'raisedBy',
    //   label: 'Action',
    //   filter: false
    // },
  ];

  serviceData: IItem[] = []
  selectedItems = [2, 3];

  // Resolution Form
  bShowResolution = false
  bValidResolution!: boolean
  resolutionText: string = ''
  resolutionForm = new FormGroup({
    resolutionControl: new FormControl(this.resolutionText, [Validators.required, Validators.minLength(5)])
  })
  userForm!: FormGroup;
  raisedUserId!: string;

  get resolutionControl() { return this.resolutionForm.get('resolutionControl') }

  ifResolutionValid() {
    if (this.resolutionControl?.invalid && (this.resolutionControl?.dirty || this.resolutionControl?.touched)) {
      this.bValidResolution = false
      return 'Enter a valid resolution'
    } else {
      if (this.resolutionControl?.dirty || this.resolutionControl?.touched)
        this.bValidResolution = true
      else
        this.bValidResolution = this.bUndefined
      return ''
    }
  }

  showResolutionModal(item: any) {
    this.selectedItem = item
    this.resolutionControl?.setValue('')
    this.resolutionText = ''
    this.bValidResolution = this.bUndefined
    this.bShowResolution = true
  }

  closeResolutionModal() {
    this.bShowResolution = false
  }

  onStartDateChane(event: any) {
    this.startDate = event
    this.serviceData = []
  }

  onEndDateChane(event: any) {
    this.endDate = event
    this.serviceData = []
  }

  onSelectChange() {
    this.serviceData = []
  }

  constructor(private restApi: RestService, private datePipe: DatePipe, private changeDetector: ChangeDetectorRef, private router: Router) {

  }

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  getDateString(dateValue: Date) {
    return this.datePipe.transform(dateValue, "yyyy-MM-dd")
  }

  getDisplayDate(item: any) {
    return this.datePipe.transform(item.dateCreated, "dd-MM-yyyy")
  }

  ngOnInit() {
    this.loadServiceTypes()
  }

  loadServiceTypes() {
    this.restApi.getServiceTypesComplaints().subscribe({
      next: (v: ServiceTypes) => {
        if (v.success) {
          this.serviceTypes = v.serviceTypes 
        }
      },
      error: (e) => {

      }
    })
  }

  closeAlert(event: any) {

  }

  alertVisibility(event: any) {
    this.bAlert = event.state
  }

  showAlertBox(heading: string, body: string, closeButtonText: string = "Close", showSecondButton: boolean = false, secondButtonText: string = "Understood", data: any = {}) {
    this.alertHeaderText = heading
    this.alertBodyText = body
    this.bShowSecondAlertButton = showSecondButton
    this.alertSecondButtonText = secondButtonText
    this.alertCloseButtonText = closeButtonText
    this.alertBoxData = data
    this.bAlert = true
  }

  onAlertButtonClick(event: any) {
    this.bAlert = event.state
    if (event.data.action === 1) {
    }
  }

  // Search Form
  searchServiceType: string = 'All'
  searchTicketType: string = 'All Tickets'

  cifSearchForm = new FormGroup({
    searchServiceTypeControl: new FormControl(this.searchServiceType),
    searchTicketTypeControl: new FormControl(this.searchTicketType),
  })

  get searchServiceTypeControl() { return this.cifSearchForm.get('searchServiceTypeControl') }
  get searchTicketTypeControl() { return this.cifSearchForm.get('searchTicketTypeControl') }

  getServices() {
    let showTicketType = 1

    if (this.searchServiceTypeControl?.value == null || this.searchServiceTypeControl?.value == '' || this.searchTicketTypeControl?.value == null || this.searchTicketTypeControl?.value == '') {
      this.showAlertBox('Sorry', 'Please choose the Service Type and Ticket Type before you can search')
      return
    } else {
      if (this.searchTicketTypeControl?.value == 'Open Tickets')
        showTicketType = 1
      else if (this.searchTicketTypeControl?.value == 'Closed Tickets')
        showTicketType = 2
      else
        showTicketType = 3

      let startDateString = this.getDateString(this.startDate)
      let endDateString = this.getDateString(this.endDate)

      if (startDateString != null && endDateString != null) {
        this.restApi.getServiceRequests(this.searchServiceTypeControl?.value, startDateString, endDateString, showTicketType, 2).subscribe({
          next: (v: ServiceRequests) => {
            this.serviceData = v.serviceRequests.map((item, Reference) => {
              const _selected = this.selectedItems.includes(Reference);
              return {
                ...item,
                _selected
              };
            })
          },
          error: (e) => {

          }
        })
      } else {
        this.showAlertBox('Sorry', 'Please correct the dates')
      }
    }
  }

  updateStatus(userData: any) {
    this.currentComplaintIsOpen = userData.isOpen;
    const initialStatus = userData.isOpen == true ? 'Open' : 'Resolved'
    const isInitiallyResolved = initialStatus === 'Resolved'
    const selectedRowInternalRemarks = this.getRowInternalRemarks(userData)

    this.userForm = new FormGroup({
      complainNo: new FormControl({ value: userData.requestId, disabled: true }),
      status: new FormControl(initialStatus),
      sendRemarksToCustomer: new FormControl({ value: isInitiallyResolved, disabled: isInitiallyResolved }),
      cif: new FormControl({ value: userData.cif || '', disabled: true }),
      customerName: new FormControl({ value: userData.customerName || '', disabled: true }),
      category: new FormControl({ value: userData.requestType || '', disabled: true }),
      complaintType: new FormControl(userData.response || ''),
      internalRemarks: new FormControl(selectedRowInternalRemarks),
      remarks: new FormControl({ value: userData.remark || '', disabled: true }),

    });

    // this.documents = userData.documents;

    // Group documents for display
    this.documentGroups = [
      { label: 'Documents', docs: userData.documents || [] }
    ];

    // Show the user form after data is populated
    this.showUserForm = true;

    this.userForm.get('status')?.valueChanges.subscribe((statusValue) => {
      const sendRemarksControl = this.userForm.get('sendRemarksToCustomer')
      if (!sendRemarksControl) return

      if (statusValue === 'Resolved') {
        sendRemarksControl.setValue(true, { emitEvent: false })
        sendRemarksControl.disable({ emitEvent: false })
      } else {
        sendRemarksControl.enable({ emitEvent: false })
        sendRemarksControl.setValue(false, { emitEvent: false })
      }
    })

    this.userForm.markAsPristine()


    // this.router.navigate(['/home/supportcomplaints/update-status', id.requestId]);
  }

  getStatusBadge(item: any) {
    if (item.isOpen)
      return 'danger'
    else
      return 'success'
  }

  getStatus(item: any) {
    if (item.isOpen)
      return 'Open'
    else
      return 'Resolved'
  }

  showResolveButton(item: any) {
    return true;
  }

  getActionButtonText(item: any) {
    return item.isOpen ? 'Update Status' : 'View Details';
  }

  getResolutionDate(item: any) {
    if (item.isOpen)
      return ''
    else
      return item.resolvedOn
  }

  getRowInternalRemarks(item: any): string {
    return item?.internalRemarks || item?.relevantData || ''
  }

  canUpdateForm(): boolean {
    return !!this.userForm && this.userForm.dirty && this.currentComplaintIsOpen
  }

  hasRequiredRemarks(status: string, internalRemarks: string, resolutionRemarks: string): boolean {
    const internalRemarksValue = (internalRemarks || '').trim()
    const resolutionValue = (resolutionRemarks || '').trim()

    if (status === 'Open' && !internalRemarksValue) {
      this.userForm?.get('internalRemarks')?.markAsTouched()
      this.showAlertBox('Validation', 'Internal Remarks are mandatory when Status is Open')
      return false
    }

    if (status === 'Resolved' && !resolutionValue) {
      this.userForm?.get('complaintType')?.markAsTouched()
      this.showAlertBox('Validation', 'Resolution Remarks are mandatory when Status is Resolved')
      return false
    }

    return true
  }

  processResolution() {
    this.resolutionControl?.markAsTouched()
    const internalRemarks = this.userForm.get('internalRemarks')?.value || ''
    if (this.resolutionForm.valid && this.resolutionControl?.value != null) {
      this.restApi.resolveServiceRequest(this.selectedItem.requestId, this.resolutionControl?.value, internalRemarks, "Resolved").subscribe({
        next: (v: GenericResponse) => {
          if (v.success) {
            this.bShowResolution = false
            this.getServices()
          } else {
            this.showAlertBox('Sorry', 'There was a technical issue. Please contact the support')
          }
        },
        error: (e) => {
          this.showAlertBox('Sorry', 'There was a technical issue. Please contact the support')
        }
      })
    } else {
      this.bValidResolution = false
    }
  }

  onRowClick(rowData: any) {
    this.updateStatus(rowData.item);
  }

  onUserFormSaveClick() {
    if (this.userForm.valid) {
      if (!this.canUpdateForm()) return

      const formData = {
        complainNo: this.userForm.get('complainNo')?.value || '',
        status: this.userForm.get('status')?.value || '',
        cif: this.userForm.get('cif')?.value || '',
        customerName: this.userForm.get('customerName')?.value || '',
        category: this.userForm.get('category')?.value || '',
        complaintType: this.userForm.get('complaintType')?.value || '',
      };

      const internalRemarks = this.userForm.get('internalRemarks')?.value || ''
      const sendRemarksToCustomer = !!this.userForm.get('sendRemarksToCustomer')?.value
      const resolutionRemarks = this.userForm.get('complaintType')?.value || ''
      const status = this.userForm.get('status')?.value || ''

      if (!this.hasRequiredRemarks(status, internalRemarks, resolutionRemarks)) {
        return
      }

      const shouldSendEmail = sendRemarksToCustomer || (status === 'Resolved' && !!resolutionRemarks.trim())

      this.restApi.resolveServiceRequest(formData.complainNo, formData.complaintType, internalRemarks, formData.status, shouldSendEmail).subscribe({
        next: (v: GenericResponse) => {
          if (v.success) {
            this.userForm.markAsPristine()
            this.showAlertBox('Success', 'Service request updated successfully')
            this.showUserForm = false;
            this.getServices()
          } else {
            this.showAlertBox('Sorry', 'There was a technical issue. Please contact the support')
          }
        },
        error: (e) => {
          this.showAlertBox('Sorry', 'There was a technical issue. Please contact the support')
        }
      })


    } else {
      alert('Please fill in all required fields.');
    }
  }

  resetForm() {
    this.showUserForm = false;
    this.currentComplaintIsOpen = true;
    this.getServices();
  }

  downloadDocument(documentData: GetDocumentData) {
    const byteCharacters = atob(documentData.base64Data);
    const byteNumbers = Array.from(byteCharacters).map(char => char.charCodeAt(0));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray]);

    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = documentData.documentName;
    link.click();
  }

  getFileIconClass(filename: string): string {
    const extension = filename?.split('.').pop()?.toLowerCase();

    switch (extension) {
      case 'pdf':
        return 'fas fa-file-pdf text-danger';
      case 'doc':
      case 'docx':
        return 'fas fa-file-word text-primary';
      case 'xls':
      case 'xlsx':
        return 'fas fa-file-excel text-success';
      case 'jpg':
      case 'jpeg':
      case 'png':
        return 'fas fa-file-image text-warning';
      case 'txt':
        return 'fas fa-file-alt text-muted';
      default:
        return 'fas fa-file text-secondary';
    }
  }

  truncateFileName(filename: string, startChars: number = 12, endChars: number = 10): string {
    if (!filename) return '';
    if (filename.length <= startChars + endChars + 3) return filename;

    const start = filename.substring(0, startChars);
    const end = filename.substring(filename.length - endChars);
    return `${start}...${end}`;
  }
}
